module.exports = __webpack_public_path__ + "img/1535373808.beeceeac.jpg";